import React from 'react'
import styled from 'styled-components'
import { Container, Col, Row } from 'react-bootstrap'
import SharedTitle from '~/components/UI/SharedTitle'
import Text from '~/components/UI/Text'
import { useTranslation } from '~/i18n'
import Box from '~/components/UI/Box'

const MyContainer = styled.div`
  padding: 40px 0;
`

const ContentBox = styled(Box)`
  padding: 24px;
  min-height: 120px;
  border-radius: 16px;
  background-color: #ebf3ff;

  p:first-child {
    margin-bottom: 8px;
  }
`

const Section7Tax = () => {
  const [t] = useTranslation()
  return (
    <MyContainer>
      <Container>
        <SharedTitle centered padding='0 0 32px 0'>
          {t`Biểu phí & Thuế`}
        </SharedTitle>
        <Row>
          <Col className='mb-4' md={4}>
            <ContentBox>
              <Text>
                {t`Phí quản lý`}
              </Text>
              <Text size={24} bold>
                {t`1.5%/năm`}
              </Text>
            </ContentBox>
          </Col>
          <Col className='mb-4' md={4}>
            <ContentBox>
              <Text>
                {t`Phí giao dịch`}
              </Text>
              <Text size={24} bold>
                {t`1% giá trị giao dịch`}
              </Text>
            </ContentBox>
          </Col>
          <Col className='mb-4' md={4}>
            <ContentBox>
              <Text>
                {t`Thuế TNCN, GTTT, Bán BĐS`}
              </Text>
              <Text size={24} bold>
                {t`Theo quy định hiện hành`}
              </Text>
            </ContentBox>
          </Col>
        </Row>
      </Container>
    </MyContainer>
  )
}

export default Section7Tax
